// src/components/commandSearch/CommandSearchButton.jsx
//
// Command Search Button
// =====================
//
// PURPOSE
// -------
// Compact navbar entry point for Command Search.
//
// This component contains no search logic.
// It only opens the provider-owned dialog.
//
// I18N NOTE
// ---------
// The button is rendered inside the authenticated application shell, so it uses
// the current runtime language from i18next. It must not read or persist any
// profile-language setting by itself; language persistence is handled elsewhere.

import React from "react";
import { useTranslation } from "react-i18next";

import { useCommandSearch } from "./CommandSearchProvider";
import "./CommandSearch.css";

export default function CommandSearchButton() {
  const { t } = useTranslation("commandSearch");
  const { openCommandSearch } = useCommandSearch();

  return (
    <button
      type="button"
      className="command-search-button"
      onClick={openCommandSearch}
      aria-label={t("button.ariaLabel")}
      title={t("button.title")}
    >
      <span className="command-search-button__icon" aria-hidden="true">
        ⌕
      </span>

      <span className="command-search-button__text">
        {t("button.text")}
      </span>

      <kbd className="command-search-button__shortcut">Ctrl K</kbd>
    </button>
  );
}
